import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiClient } from "app/configs/apiClient";
import toast from "react-hot-toast";

// get review data
export const getGoogle = createAsyncThunk(
  "/google/oauth",
  async ({url}) => {
    const response = await apiClient().get(url);
    return response.data;
  }
);

// get facebook auth url
export const getFacebookAuthUrl = createAsyncThunk(
  "/meta/auth-url",
  async ({url}) => {
    const response = await apiClient().get(url);
    return response.data;
  }
);

export const getGoogleCode = createAsyncThunk(
  "google/business/accounts?code=",
  async ({code,url}) => {

    const response = await apiClient().get(`${url}${code}`);
    return response.data;
  }
);

// give code retrieved from facebook redirection url back to BE
export const getFacebookCodeCallback = createAsyncThunk(
  "/meta/callback",
  async ({code, gatewayDetailsId, platformId, url, companyId}) => {
    const response = await apiClient().get(`${url}?code=${code}&gateway_details_id=${gatewayDetailsId}&platform_id=${platformId}&companyId=${companyId}`);
    return response.data;
  }
);

// get Facebook pages
export const getFacebookPages = createAsyncThunk(
  "/meta/pages",
  async ({ url, gatewayDetailsId, platformId }) => {
    const response = await apiClient().get(`${url}?gateway_details_id=${gatewayDetailsId}&platform_id=${platformId}`);
    return response?.data ?? [];
  }
);

// post selected page details
export const postSelectedFBPageDetails = createAsyncThunk(
  "/meta/post-details",
  async ({ url, pageName, pageId, pageToken, platformId, gatewayDetailsId }) => {
    const response = await apiClient().post(url, {
      pageName: pageName,
      page_id: pageId,
      page_token: pageToken,
      platform_id: platformId,
      gateway_details_id: gatewayDetailsId,
    });
    return response?.data ?? [];
  }
);

// unlink Facebook Integration
export const unlinkFacebookIntegration = createAsyncThunk(
  "/meta/reset",
  async ({ url, platformId, gatewayDetailsId }) => {
    const response = await apiClient().post(url, {
      platform_id: platformId,
      gateway_details_id: gatewayDetailsId,
    });
    return response?.data ?? [];
  }
);

// patch for comment adding
export const selectGoogleBusiness = createAsyncThunk(
  "/google/business/account",
  async (params, thunkAPI) => {
    console.log({ params },"paramsss????");
    const { body, name, url } = params;
    const response = await apiClient().put(url, {
      name,
    });
    console.log({ response: response });
    return response.data;
  }
);

const initialState = {
  googleIntegration: "",
  googleCode:[],
  facebookAuthUrl: '',
};

const integrationSlice = createSlice({
  name: "message",
  initialState,

  extraReducers: (builder) => {
    builder.addCase(getGoogle.fulfilled, (state, action) => {
      state.googleIntegration = action.payload.data.redirectUrl;
    });
    builder.addCase(getGoogle.pending, (state, action) => {
    });
    builder.addCase(getGoogle.rejected, (state, action) => {
    });
    builder.addCase(getGoogleCode.fulfilled, (state, action) => {
      state.googleCode = action.payload.data.accounts
    });
    builder.addCase(getGoogleCode.pending, (state, action) => {
    });
    builder.addCase(getGoogleCode.rejected, (state, action) => {
    });
    builder.addCase(selectGoogleBusiness.fulfilled, (state, action) => {
      toast.success("Business account added successfully");
      state.googleCode=[];
    });
    builder.addCase(selectGoogleBusiness.pending, (state, action) => {
    });
    builder.addCase(selectGoogleBusiness.rejected, (state, action) => {
      console.error("Error deleting user review:", action.error);
    });
    builder.addCase(getFacebookAuthUrl.fulfilled, (state, action) => {
      state.facebookAuthUrl = action.payload.url;
    });
    builder.addCase(getFacebookAuthUrl.pending, (state, action) => {
    });
    builder.addCase(getFacebookAuthUrl.rejected, (state, action) => {
    });
    builder.addCase(getFacebookCodeCallback.fulfilled, (state, action) => {
    });
    builder.addCase(getFacebookCodeCallback.pending, (state, action) => {
    });
    builder.addCase(getFacebookCodeCallback.rejected, (state, action) => {
    });
    builder.addCase(getFacebookPages.fulfilled, (state, action) => {
    });
    builder.addCase(getFacebookPages.pending, (state, action) => {
    });
    builder.addCase(getFacebookPages.rejected, (state, action) => {
    });
    builder.addCase(postSelectedFBPageDetails.fulfilled, (state, action) => {
    });
    builder.addCase(postSelectedFBPageDetails.pending, (state, action) => {
    });
    builder.addCase(postSelectedFBPageDetails.rejected, (state, action) => {
    });
    builder.addCase(unlinkFacebookIntegration.fulfilled, (state, action) => {
    });
    builder.addCase(unlinkFacebookIntegration.pending, (state, action) => {
    });
    builder.addCase(unlinkFacebookIntegration.rejected, (state, action) => {
    });
  },
});

export default integrationSlice.reducer;
